{
  "name": "Paiement à la livraison",
  "description": "Payez en espèces à la réception de votre commande",
  "eligibility": {
    "eligible": "Paiement à la livraison disponible",
    "not_eligible": "Paiement à la livraison non disponible",
    "min_amount": "Montant minimum : {{amount}} FCFA",
    "max_amount": "Montant maximum : {{amount}} FCFA",
    "zone_restricted": "Non disponible dans votre zone de livraison",
    "max_pending": "Vous avez atteint le nombre maximum de commandes en cours"
  },
  "verification": {
    "title": "Vérification du numéro",
    "subtitle": "Un code de vérification sera envoyé par SMS",
    "enter_code": "Entrez le code reçu par SMS",
    "resend": "Renvoyer le code",
    "resend_countdown": "Renvoyer dans {{seconds}}s",
    "verified": "Numéro vérifié",
    "invalid_code": "Code invalide",
    "expired": "Code expiré, veuillez en demander un nouveau"
  },
  "confirmation": {
    "title": "Commande confirmée — Paiement à la livraison",
    "amount_due": "Montant à payer : {{amount}} FCFA",
    "instructions": "Préparez le montant exact pour le livreur",
    "no_change": "Le livreur ne rend pas la monnaie"
  },
  "admin": {
    "title": "Paramètres paiement à la livraison",
    "enabled": "Activer le paiement à la livraison",
    "min_amount": "Montant minimum (FCFA)",
    "max_amount": "Montant maximum (FCFA)",
    "zones": "Zones autorisées",
    "phone_verification": "Vérification téléphonique obligatoire",
    "max_pending": "Nombre max de commandes en cours par client",
    "save": "Enregistrer"
  }
}
